import { BomPartHelper } from 'bom/helpers';
import { IBomPart } from 'bom/types';

import { ICopyMoveToElementRecord } from './types';

export const convertBomPartsToCopyMoveToElementRecords = (
  bomParts: IBomPart[]
): ICopyMoveToElementRecord[] => {
  return bomParts.map((bomPart) => ({
    id: bomPart.componentId,
    partNumber: BomPartHelper.getDisplayedPartNumber(bomPart),
    componentName: bomPart.componentName,
    uom: bomPart.uom,
    description: bomPart.partArr?.description,
    currentQuantity: bomPart.quantity,
    quantity: null,
    type: bomPart.type,
    elements: bomPart.elements,
    isValid: true,
  }));
};
